import React from "react";
import styled from "styled-components";
import { Button } from "ui-kit/Button";
import { Modal } from "ui-kit/Modal";
import {FormattedMessage} from "react-intl";

interface DeleteLabelModalProps {
  deleting: boolean;
  isOpen: boolean;
  onHide: () => void;
  onDeleteLabel: () => void;
}

export const DeleteLabelModal: React.FC<DeleteLabelModalProps> = props => {
  const { isOpen, onHide, onDeleteLabel, deleting } = props;

  return (
    <Modal
      visible={isOpen}
      onHide={onHide}
      header={(
        <FormattedMessage
          id="Labels.DeleteLabelModal.Question"
          defaultMessage="Are you sure you want to delete the label?"
        />
      )}
    >
      <ModalContainer>
        <ModalFooter>
          <NoButton loading={deleting} onClick={onHide}>
            <FormattedMessage
              id="Labels.DeleteLabelModal.No"
              defaultMessage="No"
            />
          </NoButton>
          <Button loading={deleting} onClick={onDeleteLabel}>
            <FormattedMessage
              id="Labels.DeleteLabelModal.Yes"
              defaultMessage="Yes"
            />
          </Button>
        </ModalFooter>
      </ModalContainer>
    </Modal>
  );
};

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 530px;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  height: 46px;
  margin: 4px 0;
`;

const NoButton = styled(Button)`
  background-color: #ffffff;
  border-color: #ffffff;
  color: #000000;
`;
